import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useScrollShrink } from "../../services/useScrollShrink";
import { FAVOURITES_PATH, HOME_PATH, HOME_SEARCH_PATH, NOTIFCATION_PATH, PROFILE_PATH, REGISTER_PATH, SUBSCRIPTION_PATH } from "../../utility/path";
import "../../BottomNav.css";

const BottomNav = ({ alertCount = 0 }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const authData = useSelector((state) => state?.auth?.data);
  const compact  = useScrollShrink();

  const isLoggedIn = authData?.isLoggedIn;
  const isProducer = authData?.role === "producer";
  const isConsumer = authData?.role === "consumer";
  const isAdmin    = authData?.isAdmin;

  const backToHomePath = location?.pathname === HOME_PATH ? HOME_SEARCH_PATH : HOME_PATH;


  // icon = inactive (outline), iconActive = active (solid)
  const NAV_ITEMS = [
    { label: "Home", path: backToHomePath , paths: [HOME_PATH, HOME_SEARCH_PATH],
      icon: "fa-home", iconActive: "fa-home", show: true },
    { label: "Subscription", path: SUBSCRIPTION_PATH, paths: [SUBSCRIPTION_PATH],
      icon: "fa-credit-card", iconActive: "fa-credit-card", show: isLoggedIn },
    { label: "Saved", path: FAVOURITES_PATH, paths: [FAVOURITES_PATH],
      icon: "fa-heart-o", iconActive: "fa-heart",
      show: isLoggedIn && (isConsumer || isAdmin) },
    { label: "Alerts", path: NOTIFCATION_PATH, paths: [NOTIFCATION_PATH],
      icon: "fa-bell-o", iconActive: "fa-bell", show: isLoggedIn, badge: alertCount },
    { label: isLoggedIn ? "Profile" : "Login",
      path:  isLoggedIn ? PROFILE_PATH : REGISTER_PATH,
      paths: isLoggedIn ? [PROFILE_PATH] : [REGISTER_PATH],
      icon:       isLoggedIn ? "fa-user-o" : "fa-sign-in",
      iconActive: isLoggedIn ? "fa-user"   : "fa-sign-in",
      show: true },
  ].filter((item) => item.show);

  const isActive = (paths = []) =>
    paths.some((p) => location.pathname === p || location.pathname.startsWith(p + "/"));

  const activeIndex = NAV_ITEMS.findIndex((item) => isActive(item.paths));

  // Brief "lens" effect while the bubble travels between tabs
  const [moving, setMoving] = useState(false);
  const prevIndex = useRef(activeIndex);

  useEffect(() => {
    const changed = prevIndex.current !== activeIndex &&
                    prevIndex.current !== -1 && activeIndex !== -1;
    prevIndex.current = activeIndex;
    if (!changed) return;

    setMoving(true);
    const t = setTimeout(() => setMoving(false), 380);
    return () => clearTimeout(t);
  }, [activeIndex]);

  return (
    <nav
      className={`bn-wrap ${compact ? "bn-wrap--compact" : ""}`}
      role="navigation"
      aria-label="Bottom navigation"
    >
      <div
        className="bn-bar"
        style={{ "--bn-count": NAV_ITEMS.length, "--bn-index": Math.max(activeIndex, 0) }}
      >
        {/* Sliding glass bubble behind the active tab */}
        <span
          aria-hidden="true"
          className={`bn-pill ${activeIndex === -1 ? "bn-pill--hidden" : ""} ${moving ? "bn-pill--moving" : ""}`}
        />

        {NAV_ITEMS.map((item) => {
          const active = isActive(item.paths);
          return (
            <button
              key={item.path}
              className={`bn-item ${active ? "bn-item--active" : ""}`}
              onClick={() => navigate(item.path)}
              aria-label={item.label}
              aria-current={active ? "page" : undefined}
            >
              <span className="bn-item__icon-wrap">
                <i className={`fa ${active ? item.iconActive : item.icon} bn-item__icon`} />
                {item.badge > 0 && (
                  <span className="bn-badge">{item.badge > 9 ? "9+" : item.badge}</span>
                )}
              </span>
              <span className="bn-item__label">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;